const fetchUrl = process.env.MIX_APP_URL ? process.env.MIX_APP_URL : window.location.origin + '/';
const availableFlags = ["CA","GB","DE","CZ","AU","FR","RO","IT","CN","TR","PL","UA","US"];

export {fetchUrl, availableFlags}
